import UIkit from 'uikit';
import Swiper, {Navigation, Manipulation} from 'swiper';

Swiper.use([Navigation, Manipulation]);

export default function () {
    let slides = {};
    let doctorsContainer = UIkit.util.$$('.tm-doctors');

    UIkit.util.each(doctorsContainer, (container) => {
        setTimeout(() => {
            const wrapper = UIkit.util.closest(container, '.uk-container');
            const isDense = UIkit.util.hasClass(wrapper, 'uk-container-small');
            const sliderEl = UIkit.util.$('.swiper', container);
            const filterInstance = UIkit.switcher('.tm-doctors-filter .uk-subnav');
            let filterActiveIndex = filterInstance.index();

            let sliderInstance = new Swiper(sliderEl, {
                speed: 400,
                slidesPerView: 2,
                spaceBetween: 20,
                freeMode: true,
                noSwipingClass: 'tm-doctors__item',
                allowTouchMove: false,
                grabCursor: true,
                watchOverflow: true,
                breakpoints: {
                    600: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                    960: {
                        slidesPerView: 3,
                        spaceBetween: isDense ? 40 : 60,
                        noSwiping: false,
                        freeMode: false,
                        allowTouchMove: true,
                    },
                    1264: {
                        slidesPerView: 4,
                        spaceBetween: isDense ? 40 : 60,
                        noSwiping: false,
                        freeMode: false,
                        allowTouchMove: true,
                    },
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                on: {
                    init: function () {
                        slides = this.slides;
                    },
                },
            });

            UIkit.util.on(filterInstance.$el, 'click', function () {
                let newFilterActiveIndex = filterInstance.index();

                if (newFilterActiveIndex !== filterActiveIndex) {
                    filterActiveIndex = newFilterActiveIndex;

                    let toggleEl = filterInstance.toggles[newFilterActiveIndex];
                    let filterSpecialization = toggleEl.dataset.filter;

                    sliderInstance.removeAllSlides();

                    UIkit.util.each(slides, function (slide) {
                        if (UIkit.util.data(slide, 'specialization') === filterSpecialization || !filterSpecialization) {
                            if (UIkit.util.isNode(slide)) {
                                sliderInstance.appendSlide(slide);
                            }
                        }
                    });
                }
            });
        }, 1000);
    });
}



// WEBPACK FOOTER //
// ./scripts/partials/doctors.js